import React, {Fragment, Component} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Row, Col, Input, message, Tabs, Card, Switch, Button} from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons';

import AdminLayout from 'components/elements/AdminLayout'
import SectionContent from 'components/elements/SectionContent'

import {
  integrationConfigActions,
  administratorActions
} from 'actions'

const { Search } = Input
const pageTitle = 'Users'
const storeKey = 'accounts'
const createPath = `/${otterStore.getState().config.key}/admin/patients/create`
const editPath = `/${otterStore.getState().config.key}/admin/patients/edit`
const _ = require('lodash')
const { TabPane } = Tabs
class Integrations extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      evet: {
        active: _.get(props, "integrationConfigs['evet'].active", false),
        fetchActive: _.get(props, "integrationConfigs['evet'].fetchActive", false),
        transcribeActive: _.get(props, "integrationConfigs['evet'].transcribeActive", false),
        data: _.get(props, "integrationConfigs['evet'].data", {})
      },
      vetter: {
        active: _.get(props, "integrationConfigs['vetter'].active", false),
        data: _.get(props, "integrationConfigs['vetter'].data", {})
      },
      gravity: {
        active: _.get(props, "integrationConfigs['gravity'].active", false),
        data: _.get(props, "integrationConfigs['gravity'].data", {})
      },
      covetrus: {
        active: _.get(props, "integrationConfigs['covetrus'].active", false),
        fetchActive: _.get(props, "integrationConfigs['covetrus'].fetchActive", false),
        transcribeActive: _.get(props, "integrationConfigs['covetrus'].transcribeActive", false),
        data: _.get(props, "integrationConfigs['covetrus'].data", {})
      },
      datapoint: {
        active: _.get(props, "integrationConfigs['datapoint'].active", false),
        fetchActive: _.get(props, "integrationConfigs['datapoint'].fetchActive", false),
        transcribeActive: _.get(props, "integrationConfigs['datapoint'].transcribeActive", false),
        data: _.get(props, "integrationConfigs['datapoint'].data", {})
      },
      rhapsody: {
        active: _.get(props, "integrationConfigs['rhapsody'].active", false),
        fetchActive: _.get(props, "integrationConfigs['rhapsody'].fetchActive", false),
        transcribeActive: _.get(props, "integrationConfigs['rhapsody'].transcribeActive", false),
        data: _.get(props, "integrationConfigs['rhapsody'].data", {})
      }
    }
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.handleToggleEvet = this.handleToggleEvet.bind(this)
    this.handleToggleEvetTranscribe = this.handleToggleEvetTranscribe.bind(this)
    this.handleToggleEvetFetch = this.handleToggleEvetFetch.bind(this)
    this.handleToggleEvetFollowUps = this.handleToggleEvetFollowUps.bind(this)
    
    this.handleToggleRhapsodyTranscribe = this.handleToggleRhapsodyTranscribe.bind(this)
    this.handleToggleRhapsodyFetch = this.handleToggleRhapsodyFetch.bind(this)

    this.handleToggleVetter = this.handleToggleVetter.bind(this)
    
    this.handleToggleGravity = this.handleToggleGravity.bind(this)
    this.handleToggleGravityProduction = this.handleToggleGravityProduction.bind(this)
    
    this.handleToggleCovetrus = this.handleToggleCovetrus.bind(this)
    this.handleToggleCovetrusTranscribe = this.handleToggleCovetrusTranscribe.bind(this)
    this.handleToggleCovetrusFetch = this.handleToggleCovetrusFetch.bind(this)
    
    this.handleToggleDatapointTranscribe = this.handleToggleDatapointTranscribe.bind(this)
    this.handleToggleDatapointFetch = this.handleToggleDatapointFetch.bind(this)
    this.handleToggleDatapoint = this.handleToggleDatapoint.bind(this)


    this.handlePlaceholderTargetIDSubmit = this.handlePlaceholderTargetIDSubmit.bind(this)
    this.handleChangePlaceholderPatientID = this.handleChangePlaceholderPatientID.bind(this)
    this.handlePlaceholderTargetIDRemove = this.handlePlaceholderTargetIDRemove.bind(this)
    this.handleTranscribeBlock = this.handleTranscribeBlock.bind(this)
  }

  componentDidMount() {
    this.fetch()
  }

  fetch() {
    integrationConfigActions.fetch()
  }

  onSubmit(integration, e){
    e.preventDefault()

    integrationConfigActions.update({
      ...this.props.integrationConfigs[integration],
      integration,
      data: this.state[integration].data,
      active: true
    })
  }
  
  diff(previousProps, ...keys){
    let options = {};

    for(let key of keys){
      const previous = _.get(previousProps, key)
      const next = _.get(this.props, key) 
      
      if(previous != next){
        _.set(options, key, next)
      }
    }    
    return options;
  }

  get placeholderTargetPatientIDs() {
    return this.state.covetrus.data.placeholderTargetPatientIDs || []
  }
  
  
// clear text box on submission
// remove IDs from list with button press
  handlePlaceholderTargetIDSubmit(e) {
    if(e.keyCode == 13) {
      e.preventDefault()
      let placeholderTargetPatientIDs = this.placeholderTargetPatientIDs
      placeholderTargetPatientIDs.push(e.target.value)
      let integrationConfig = this.state.covetrus
      integrationConfig.data.placeholderTargetPatientIDs = placeholderTargetPatientIDs
      this.setState({
        covetrus: integrationConfig,
        placeholderPatientID: ''
      })
    }
  }

  handleChangePlaceholderPatientID(e) {
    this.setState({
      placeholderPatientID: e.target.value
    }) 
  }

  handlePlaceholderTargetIDRemove(id){
    let integrationConfig = this.state.covetrus
    integrationConfig.data.placeholderTargetPatientIDs = (
      integrationConfig.data.placeholderTargetPatientIDs.filter((_id)=>
        id !== _id
      )
    )
    this.setState({
      covetrus: integrationConfig
    })
  }

  componentDidUpdate(previousProps){
    const options = this.diff(
      previousProps,
      'integrationConfigs.evet.active',
      'integrationConfigs.evet.fetchActive',
      'integrationConfigs.evet.transcribeActive',
      'integrationConfigs.evet.data',
      
      'integrationConfigs.rhapsody.fetchActive',
      'integrationConfigs.rhapsody.transcribeActive',
      'integrationConfigs.rhapsody.data.id',

      'integrationConfigs.vetter.data.apiKey',
      'integrationConfigs.vetter.active',

      'integrationConfigs.gravity.data.oid',
      'integrationConfigs.gravity.data.authToken',
      'integrationConfigs.gravity.active',

      'integrationConfigs.covetrus.active',
      'integrationConfigs.covetrus.fetchActive',
      'integrationConfigs.covetrus.transcribeActive',
      'integrationConfigs.covetrus.data',

      'integrationConfigs.datapoint.active',
      'integrationConfigs.datapoint.fetchActive',
      'integrationConfigs.datapoint.transcribeActive',
      'integrationConfigs.datapoint.data'
    )
    
    const integrationConfigs = options.integrationConfigs || {}

    if(this.props.integrationConfigs != previousProps.integrationConfigs) {

      this.setState(
        JSON.parse(
          JSON.stringify({
            evet: {
              ...this.state.evet || {},
              ...integrationConfigs.evet || {}
            },
            rhapsody: {
              ...this.state.rhapsody || {},
              ...integrationConfigs.rhapsody || {}
            },
            vetter: {
              ...this.state.vetter || {},
              ...integrationConfigs.vetter || {}
            },
            gravity: {
              ...this.state.gravity || {},
              ...integrationConfigs.gravity || {}
            },
            covetrus: {
              ...this.state.covetrus || {},
              ...integrationConfigs.covetrus || {}
            },
            datapoint: {
              ...this.state.datapoint || {},
              ...integrationConfigs.datapoint || {}
            }
          })
        )
      )
    }
  }
  
  onChange(type, target, e){
    const data  = (this.state[type] || {
      data:{}
    }).data || {}
    const integration = {...this.state[type]}
    data[target] = e.target.value
    integration.data = {...data}
    
    this.setState({
      [`${type}`]: integration
    })
  }
  
  handleToggleEvet(active){
    let evetConfig = this.state.evet || {}
    evetConfig.active = active
    this.setState({
      evet: evetConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'evet',
        active: Boolean(active)
      })
    })
  }

  handleToggleEvetFetch(active){
    let evetConfig = this.state.evet || {}
    evetConfig.fetchActive = active

    this.setState({
      evet: evetConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'evet',
        fetchActive: Boolean(active)
      })
    })
  }

  handleToggleEvetTranscribe(active){
    let evetConfig = this.state.evet || {}
    evetConfig.transcribeActive = active
    
    this.setState({
      evet: evetConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'evet',
        transcribeActive: Boolean(active)
      })
    })
  }


  handleToggleRhapsodyFetch(active){
    let rhapsodyConfig = this.state.rhapsody || {}
    rhapsodyConfig.rhapsodyActive = active

    console.log("THIS ONE?")
    this.setState({
      rhapsody: rhapsodyConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'rhapsody',
        fetchActive: Boolean(active)
      })
    })
  }

  handleToggleRhapsodyTranscribe(active){
    let rhapsodyConfig = this.state.rhapsody || {}
    rhapsodyConfig.transcribeActive = active
    
    this.setState({
      evet: rhapsodyConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'rhapsody',
        transcribeActive: Boolean(active)
      })
    })
  }

  handleToggleEvetFollowUps(active){
    let evetConfig = this.state.evet || {}
    evetConfig.data = evetConfig.data || {}
    evetConfig.data.followUps = active
    
    this.setState({
      evet: evetConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'evet',
        data: evetConfig.data
      })
    })
  }

  handleToggleVetter(active){
    let vetterConfig = this.state.vetter || {}
    vetterConfig.active = active
    this.setState({
      vetter: vetterConfig
    }, ()=>{
      integrationConfigActions.update({
        ...this.props.integrationConfigs.vetter,
        integration: 'vetter',
        active: Boolean(active),
        data: {
          apiKey: this.state.vetter.apiKey
        }
      })
    })
  }

  handleToggleGravity(active){
    let gravityConfig = {...(this.state.gravity || {})}
    gravityConfig.active = active
    gravityConfig.data = gravityConfig.data || {}
    gravityConfig.data.staging = !!gravityConfig.data.staging

    this.setState({
      gravity: gravityConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'gravity',
        active: Boolean(active),
        data: gravityConfig.data
      })
    })
  }

  handleToggleGravityProduction(value){
    const gravity = {...this.state.gravity}
    gravity.data.staging = !value
    
    this.setState({
      gravity
    })
  }

  handleToggleCovetrus(active){
    let covetrusConfig = {...(this.state.covetrus || {})}
    covetrusConfig.active = active
    covetrusConfig.data = covetrusConfig.data || {}
    // covetrusConfig.data.staging = !!gravityConfig.data.staging

    this.setState({
      covetrus: covetrusConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'covetrus',
        active: Boolean(active),
        data: covetrusConfig.data
      })
    })
  }

  handleToggleCovetrusFetch(active){
    let covetrusConfig = this.state.covetrus || {}
    covetrusConfig.fetchActive = active

    this.setState({
      covetrus: covetrusConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'covetrus',
        fetchActive: Boolean(active)
      })
    })
  }

  handleToggleCovetrusTranscribe(active){
    let covetrusConfig = this.state.covetrus || {}
    covetrusConfig.transcribeActive = active
    this.setState({
      covetrus: covetrusConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'covetrus',
        transcribeActive: Boolean(active)
      })
    })
  }

  handleToggleDatapoint(active){
    let datapointConfig = {...(this.state.datapoint || {})}
    datapointConfig.active = active
    datapointConfig.data = datapointConfig.data || {}
    // datapointConfig.data.staging = !!gravityConfig.data.staging

    this.setState({
      datapoint: datapointConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'datapoint',
        active: Boolean(active),
        data: datapointConfig.data
      })
    })
  }

  handleToggleDatapointFetch(active){
    let datapointConfig = this.state.datapoint || {}
    datapointConfig.fetchActive = active

    this.setState({
      datapoint: datapointConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'datapoint',
        fetchActive: Boolean(active)
      })
    })
  }

  handleToggleDatapointTranscribe(active){
    let datapointConfig = this.state.datapoint || {}
    datapointConfig.transcribeActive = active
    this.setState({
      datapoint: datapointConfig
    }, ()=>{
      integrationConfigActions.update({
        integration: 'datapoint',
        transcribeActive: Boolean(active)
      })
    })
  }

  get showTranscriberToggle(){
    if(!_.get(this, 'state.evet.data.group')){
      return true
    }

    if(_.get(this, 'state.evet.data.group') && this.props.currentOrganization.parentID){
      return true
    }
    return false
  }
  handleTranscribeBlock(){
    this.setState({
      blockingStyling: {
        color: '#ff0000',
        transition: `color 0s`
      }
    }, ()=>{
      setTimeout(()=>{
        this.setState({
          blockingStyling: {
            color: '#000',
            transition: `color 8s`
          }
        })
      }, 3000)
    })
  }
  render() {
    return (
      <div>
        <AdminLayout>
          <SectionContent noPadding={true} noMargin={true}>
          <Tabs defaultActiveKey="1">
            <TabPane tab="Evet" key="1">
              <Card bordered={false}>
              {_.get(this, 'state.evet.data.id') ? (
                  <div>
                    id: {_.get(this, 'state.evet.data.id')}
                    <br />
                    host: {_.get(this, 'state.evet.data.host')}
                  </div>
                ):(
                  <div>
                    No Data from server sync
                  </div>
                )}
              </Card>
              <Card bordered={false}>
                <Switch onChange={this.handleToggleEvetFetch} checked={_.get(this, 'state.evet.fetchActive')} />
                &nbsp; 
                <strong>
                  Fetch
                </strong>
              </Card>
              {this.showTranscriberToggle ?<div>
                <Card bordered={false}>
                  <Switch onChange={this.handleToggleEvetTranscribe} checked={_.get(this, 'state.evet.transcribeActive')} />
                  &nbsp; 
                  <strong>
                    Transcribe
                  </strong>
                </Card>
              </div>
              :(
                <div>
                  <Card bordered={false}>
                  <Switch checked={false} onClick={this.handleTranscribeBlock}/>
                  &nbsp; 
                  <strong>
                    Transcribe
                  </strong>
                  <br />
                  <div 
                    style={this.state.blockingStyling}
                  >
                    <b>Important</b>
                    <br />
                    Transcribers cannot be turned on for eVet MultiOrgs until the parent organization is set
                    <br />
                    We suggest you use the following organization:
                    <br />
                    {this.state.evet.data.group.Name}
                  </div>
                  </Card>
                </div>
              )}
              <Card bordered={false}>
                <Switch onChange={this.handleToggleEvetFollowUps} checked={_.get(this, 'state.evet.data.followUps')} />
                &nbsp; 
                <strong>
                  Follow Ups (Evet Reminders)
                </strong>
              </Card>
            </TabPane>
            <TabPane tab="Rhapsody" key="2">
              <Card bordered={false}>
              {_.get(this, 'state.rhapsody.data.id') ? (
                  <div>
                    id: {_.get(this, 'state.rhapsody.data.id')}
                    <br />
                    host: {_.get(this, 'state.rhapsody.data.host')}
                  </div>
                ):(
                  <div>
                    No Data from server sync
                  </div>
                )}
              </Card>
              <Card bordered={false}>
                <Switch onChange={this.handleToggleRhapsodyFetch} checked={_.get(this, 'state.rhapsody.fetchActive')} />
                &nbsp; 
                <strong>
                  Fetch
                </strong>
              </Card>
              <div>
                <Card bordered={false}>
                  <Switch onChange={this.handleToggleRhapsodyTranscribe} checked={_.get(this, 'state.rhapsody.transcribeActive')} />
                  &nbsp; 
                  <strong>
                    Transcribe
                  </strong>
                </Card>
              </div>
              {/* <Card bordered={false}>
                <Switch onChange={this.handleToggleEvetFollowUps} checked={this.state.evet.data.followUps} />
                &nbsp; 
                <strong>
                  Follow Ups (Evet Reminders)
                </strong>
              </Card> */}
            </TabPane>
            <TabPane tab="Vetter" key="3">
              <Card bordered={false}>
                <Switch onChange={this.handleToggleVetter} checked={_.get(this, 'state.vetter.active')} />
                <br />
                {this.state.vetter.active && (
                  <form onSubmit={this.onSubmit.bind(null, 'vetter')}>
                    <Input.Group style={{width: '100%'}} compact>
                      <Input 
                        style={{width: 'calc(100% - 80px)'}}
                        value={this.state.vetter.data.apiKey}
                        onChange={this.onChange.bind(null, 'vetter', 'apiKey')}
                      />
                      <Button htmlType={'submit'}>
                        Update
                      </Button>
                    </Input.Group>
                  </form>
                )}
              </Card>
            </TabPane>
            <TabPane tab="Gravity" key="4">
              <Card bordered={false}>
                <Switch onChange={this.handleToggleGravity} checked={_.get(this, 'state.gravity.active')} />
                &nbsp; 
                <strong>
                  Gravity
                </strong>
                <br />
                <br />
                {this.state.gravity.active && (
                  <form onSubmit={this.onSubmit.bind(null, 'gravity')}>
                      OID:
                      <Input 
                        value={this.state.gravity.data.oid }
                        onChange={this.onChange.bind(null, 'gravity', 'oid')}
                        />
                      <br />
                      <br />
                      Auth Token:
                      <Input 
                        value={this.state.gravity.data.authToken}
                        onChange={this.onChange.bind(null, 'gravity', 'authToken')}
                      />
                      <br />
                      <br />
                      {administratorActions.test(_.get(this, 'props.session.account')) &&(
                        <Fragment>
                          <Switch onChange={this.handleToggleGravityProduction} checked={!_.get(this, 'state.gravity.data.staging')} /> Production
                          <br />
                          <br />
                        </Fragment>
                      )}
                      <Button htmlType={'submit'}>
                        Update
                      </Button>
                  </form>
                )}
              </Card>
            </TabPane>
            <TabPane tab="Covetrus" key="5">
            <Card bordered={false}>
                <Switch onChange={this.handleToggleCovetrusFetch} checked={_.get(this, 'state.covetrus.fetchActive')} />
                &nbsp; 
                <strong>
                  Fetch
                </strong>
              </Card>
              <Card bordered={false}>
                <Switch onChange={this.handleToggleCovetrusTranscribe} checked={_.get(this, 'state.covetrus.transcribeActive')} />
                &nbsp; 
                <strong>
                  Transcribe
                </strong>
              </Card>
              <Card bordered={false}>
                <br />
                <br />
                {(_.get(this, 'state.covetrus.transcribeActive') || _.get(this, 'state.covetrus.fetchActive')) && (
                  <form onSubmit={this.onSubmit.bind(null, 'covetrus')}>
                      Installation:
                      <Input 
                        value={this.state.covetrus.data.installation}
                        onChange={this.onChange.bind(null, 'covetrus', 'installation')}
                      />
                      <br />
                      <br />
                      Placeholder Target Client ID:
                      <Input 
                        value={this.state.covetrus.data.placeholderTargetClientID}
                        onChange={this.onChange.bind(null, 'covetrus', 'placeholderTargetClientID')}
                      />
                      <br />
                      <br />
                      Placeholder Target Patient ID:
                      {this.placeholderTargetPatientIDs.map((placeholderTargetID, i) => (
                        <li key={`placeholderPatientID-${i}`}>
                          {placeholderTargetID} <CloseCircleOutlined onClick={this.handlePlaceholderTargetIDRemove.bind(null, placeholderTargetID)}/>
                        </li>
                      ))}
                      <br />
                      <Input
                        id='patientIdSubmit'
                        value={this.state.placeholderPatientID}
                        onKeyDown={this.handlePlaceholderTargetIDSubmit}
                        onChange={this.handleChangePlaceholderPatientID}
                        // onChange={this.onChange.bind(null, 'covetrus', 'placeholderTargetPatientIDs')}
                      />
                      <br />
                      <br />
                      PIMS:
                      <Input 
                        value={this.state.covetrus.data.pims}
                        onChange={this.onChange.bind(null, 'covetrus', 'pims')}
                      />
                      <br />
                      <br />
                      <Button htmlType={'submit'}>
                        Update
                      </Button>
                  </form>
                )}
              </Card>
            </TabPane>            
            <TabPane tab="Data Point" key="6">
            <Card bordered={false}>
                <Switch onChange={this.handleToggleDatapointFetch} checked={_.get(this, 'state.datapoint.fetchActive')} />
                &nbsp; 
                <strong>
                  Fetch
                </strong>
              </Card>
              <Card bordered={false}>
                <Switch onChange={this.handleToggleDatapointTranscribe} checked={_.get(this, 'state.datapoint.transcribeActive')} />
                &nbsp; 
                <strong>
                  Transcribe
                </strong>
              </Card>
              <Card bordered={false}>
                &nbsp; 
                <br />
                <br />
                  <form onSubmit={this.onSubmit.bind(null, 'datapoint')}>
                      Site ID:
                      <Input 
                        value={_.get(this, 'state.datapoint.data.siteid')}
                        onChange={this.onChange.bind(null, 'datapoint', 'siteid')}
                      />
                      <br />
                      <br />
                      Placeholder Target Client ID:
                      <Input 
                        value={_.get(this, 'state.datapoint.data.placeholderTargetClientID')}
                        onChange={this.onChange.bind(null, 'datapoint', 'placeholderTargetClientID')}
                      />
                      <br />
                      <br />
                      Placeholder Target Patient ID:
                      <br />
                      <Input
                        id='patientIdSubmit'
                        value={_.get(this, 'state.datapoint.data.placeholderTargetPatientID')}
                        onChange={this.onChange.bind(null, 'datapoint', 'placeholderTargetPatientID')}
                      />
  
                      <br />
                      <br />
                      <Button htmlType={'submit'}>
                        Update
                      </Button>
                  </form>
              </Card>
            </TabPane>
          </Tabs>
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    integrationConfigs: state.integrationConfigs || {},
    currentOrganization: state.currentOrganization,
    session: state.session
  }
}

export default withRouter(connect(mapStateToProps)(Integrations))



// WEBPACK FOOTER //
// ./src/components/templates/Integrations/index.js